import React from 'react';
import { NativeButton, ButtonVariant } from '../components/button';
import { useNavigate } from 'react-router-dom';

export const BackButton: React.FC<
  React.PropsWithChildren<{ title: string; path?: string }>
> = ({ title, path }) => {
  const navigate = useNavigate();

  return (
    <NativeButton
      variant={ButtonVariant.Tertiary}
      onClick={() => (path ? navigate(path) : navigate(-1))}
    >
      {title}
    </NativeButton>
  );
};
